/* eslint-disable */
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useToken } from "./useToken";
import { Link } from "react-router-dom";
import Nav from "./Navigation.js";

export default function SignUp() {
  const [username, setUsername] = useState("");
  const [discord_name, setDiscord_name] = useState("");
  const [visible, setVisible] = useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [password, setPassword] = useState("");
  const { signup } = useToken();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await signup(
        username,
        discord_name,
        visible,
        question,
        answer,
        password
      );
      localStorage.setItem("username", username);
      navigate("/");
    } catch (e) {
      console.error(e);
    }
  }

  const handleToggle = () => {
    setVisible(!visible);
  };

  const handleUsernameChange = (event) => {
    setUsername(event.target.value);
  };
    const handleDiscord_nameChange = (event) => {
    setDiscord_name(event.target.value);
  };
  //   const handleVisibleChange = (event) => {
  //   setVisible(event.target.value);
  // };
    const handleQuestionChange = (event) => {
    setQuestion(event.target.value);
  };
    const handleAnswerChange = (event) => {
    setAnswer(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  return (
    <div>
      <Nav></Nav>
      <div className="flex flex-col justify-center items-center h-screen">
        <div className="border rounded bg-purple-950 flex flex-col items-center">
          <div className="py-4 px-4">
            <div className="text-white font-Open Sans text-[50px]">
              Labyrinthine Unofficial
            </div>
            <div className="text-white font-Open Sans text-[50px] text-center">
              Tracker
            </div>
          </div>
          <div className="w-full max-w-xs">
            <form
              onSubmit={handleSubmit}
              className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4"
            >
              <div className="ml-3 text-black-700 font-medium">Username</div>
              <div className="form-floating mb-3">
                <input
                  htmlFor="username"
                  onChange={handleUsernameChange}
                  value={username}
                  placeholder="Username"
                  required
                  type="text"
                  name="username"
                  id="username"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="ml-3 text-black-700 font-medium">
                Discord Name(Type None if you do not wish to share)
              </div>
              <div className="form-floating mb-3">
                <input
                  htmlFor="discord_name"
                  onChange={handleDiscord_nameChange}
                  value={discord_name}
                  placeholder="Discord Name"
                  required
                  type="text"
                  name="discord_name"
                  id="discord_name"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div>
                <div className="flex items-center">
                  <label className="flex items-center cursor-pointer">
                    <div className="relative">
                      <input
                        type="checkbox"
                        checked={visible}
                        onChange={handleToggle}
                      />
                      <div className="toggle-switch"></div>
                    </div>
                    <div className="ml-3 text-black-700 font-medium">
                      I want my added friends to see my Discord name
                    </div>
                  </label>
                </div>
              </div>
              <div className="ml-3 mt-4 text-black-700 font-medium">
                Security Question
              </div>
              <div className="text-sm">
                (Discord Name and security Question used for authentication/change requests)
              </div>
              <div className="form-floating mb-3">
                <input
                  htmlFor="question"
                  onChange={handleQuestionChange}
                  value={question}
                  placeholder="Question"
                  required
                  type="text"
                  name="question"
                  id="question"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="form-floating mb-3">
                <input
                  htmlFor="answer"
                  onChange={handleAnswerChange}
                  value={answer}
                  placeholder="Answer"
                  required
                  type="text"
                  name="answer"
                  id="answer"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="ml-3 mt-4 text-black-700 font-medium">
                Password
              </div>
              <div className="form-floating mb-3">
                <input
                  htmlFor="password"
                  onChange={handlePasswordChange}
                  value={password}
                  placeholder="Password"
                  required
                  type="password"
                  name="password"
                  id="password"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
              <div className="ml-3 mt-4 italic text-black-500 font-medium">
                (DO NOT USE A PASSWORD YOU USE ON ANY OTHER ACCOUNT)
              </div>
              <div>
                <div className="text-sm">
                  Although there are security measures for your protection, this
                  is still a simple program
                </div>
                <button
                  type="submit"
                  className="bg-gradient-to-br to-purple-500 via-black from-purple-500 bg-size-200 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                >
                  Sign up
                </button>
              </div>
              <p className="text-center text-gray-500 text-xs pt-4">
                Already Have an account?{" "}
                <Link className="text-purple-500" to="/login">
                  Login
                </Link>
              </p>
            </form>
            <p className="text-center text-gray-500 text-xs">
              &copy;2023 Panda LLC. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}



// import React, { useState } from "react";
// import { useNavigate } from "react-router";

// const CreateAccountForm = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const navigate = useNavigate();

//   const handleCreateAccount = async () => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_HOST}/api/accounts`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             username,
//             role:"pleb",
//             password,
//           }),
//         }
//       );

//       if (response.ok) {
//         // Account created successfully
//         setError("");
//         console.log("Account created successfully!");
//         navigate("/");
//       } else {
//         const data = await response.json();
//         setError(data.detail || "Error creating account");
//       }
//     } catch (error) {
//       console.error("Error creating account:", error.message);
//       setError("An unexpected error occurred");
//     }
//   };

//   return (
//     <div>
//       <h2>Create Account</h2>
//       <div>
//         <label>Username:</label>
//         <input
//           type="text"
//           value={username}
//           onChange={(e) => setUsername(e.target.value)}
//         />
//       </div>
//       <div>
//         <label>Password:</label>
//         <input
//           type="password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />
//       </div>
//       <button onClick={handleCreateAccount}>Create Account</button>
//       {error && <p style={{ color: "red" }}>{error}</p>}
//     </div>
//   );
// };

// export default CreateAccountForm;
